import React from 'react'
import { Layout, Stack, Main, Sidebar } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Seo from '@widgets/Seo'
import ContactForm from '@widgets/ContactForm'
import ContactInfo from '@widgets/ContactInfo'
import Commitment from '@widgets/Commitment'

export default props => (
  <Layout {...props}>
    <Seo title='The Runs' />
    <Divider />
    <Stack>
      <Main>
        <PageTitle
          header="The official runs"
          subheader='List of all the official runs'
        />
       
        {/*<ContactForm />*/}
        <ol>
            <li><b><i>Hyderabad Marathon - 2013 - 42.2 kms - 6:22 hours - the first one - deadly but life changing</i></b></li>
            <li>Hyderabad Marathon - 2014 - 42.2 kms - 6:14 hours</li>
            <li>Coimbatore Marathon - 2014 - 21.1 kms - 2:04 hours</li>
            <li>Delhi Marathon - 2014 - 21.1 kms - 2:08 hours</li>
            <li>Chennai Marathon - 2014 - 21.1 kms - 2:02 hours </li>
            <li>Hyderabad Marathon - 2015 - 42.2 kms - 4:29 hours</li>
            <li><b><i>Leh Ladakh - 2015 - ~ 55 kms - [time unknown] - the most memorable untimed run</i></b></li>
            <li>Bangalore Marathon - 2015 - 21.1 kms - 1:48 hours</li>
            <li>Mumbai Marathon - 2016 - 42.2 kms - 4:32 hours</li>
            <li>Hyderabad Club Run - 2016 - 21.1 kms - 1:52 hours</li>
            <li>Hyderabad Heritage Run - 2016 - 21.1 kms - 2:10 hours</li>
            <li>Hyderabad Marathon - 2016 - 21.1 kms - 2:06 hours</li>
            <li><b><i>Bengaluru Marathon - 2016 - 21.1 kms - 1:41 hours - Personal Best</i></b></li>
            <li><b><i>Mumbai Marathon - 2017 - 42.2 kms - 4:21 hours - Personal Best</i></b></li>
            <li>Hyderabad Club Run - 2017 - 21.1 kms - 2:00 hours - as pacer</li>
            <li>Hyderabad Heritage Run - 2017 - 21.1 - 2:10 hours</li>
            <li>Hyderabad Stadium Run - 2017 - 24 kms - 2:00 hours</li>
            <li>Hyderabad Marathon - 2017 - 21.1 kms - 1:58 hours - as pacer</li>
            <li>Bengaluru Marathon - 2017 - 21.1 kms - 1:47 hours</li>
            <li><b><i>Oracle Run - 2017 - 10 kms - 43 mins - Personal Best</i></b></li>
            <li>Hyderabad Ultra Marathon - 2017 - 50 kms - 7:07 hours</li>
            <li>Hyderabad Club Run - 2018 - 21.1 kms - 1:58 hours - as pacer</li>
            <li>Hyderabad Marathon - 2018 - 21.1 kms - 2:06 hours</li>
            <li>Hyderabad Marathon - 2019 - 21.1 kms - 2:17 hours</li>
            <li>Hyderabad Club Run - 2021 - 21.1 kms - 1:59 hours</li>
        </ol>
      </Main>
      
      <Sidebar>
      {/*
        <Commitment />
        <Divider />
        <ContactInfo />
        */}
      </Sidebar>
      
    </Stack>
  </Layout>
)
